/** Paying VIP subscriber (matches backend; excludes Admin). Accepts legacy "Premium" from old tokens. */
export function isVipSubscriber(userType: string | number | undefined | null): boolean {
  if (userType === undefined || userType === null) return false;
  return userType === 'Vip' || userType === 'Premium' || userType === 2;
}
